import clsx from 'clsx';
import React, { ReactElement } from 'react';
import Loading from '../Loading';
import styles from './styles.module.css';

export type ButtonProps = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
  secondary?: boolean;
  loading?: boolean;
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
  variant?: 'primary' | 'secondary';
  componentRef?: React.LegacyRef<HTMLButtonElement>;
};

export const WisoryButton = ({
  className,
  children,
  secondary,
  loading,
  icon,
  iconPosition = 'right',
  variant = 'secondary',
  componentRef,
  ...otherProps
}: ButtonProps): ReactElement => {
  return (
    <button
      className={clsx('flex items-center justify-center ', styles.wrapper, styles[variant], className)}
      ref={componentRef}
      {...otherProps}
    >
      {iconPosition === 'left' && icon}
      <span className="ml-2 mr-2">{children}</span>
      {loading && <Loading className="ml-5" radius={25} />}
      {iconPosition === 'right' && icon}
    </button>
  );
};

WisoryButton.displayName = 'WisoryButton';
